module.exports = __webpack_public_path__ + "static/media/open_truck_image.a51e4bb8.png";